module.exports = __webpack_public_path__ + "1793882494189/fonts/line-awesome.452a5b4.woff2";